// extracted by mini-css-extract-plugin
module.exports = {"CircleSpinner":"circleSpinnerLoading_CircleSpinner__1cQ-s","progressAnimation":"circleSpinnerLoading_progressAnimation__UIMyo"};